import mixitup from 'mixitup';

export const Filter = () => {
  if ($('div').is('.mix-container')) {
    new  mixitup('.mix-container', {
      animation: {
        duration: 700
      }
    });
  }
};
